import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  Tooltip,
  Avatar,
  Box,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";

const UserList = ({ users, onEdit, onDelete }) => {
  const departmentColors = {
    Sales: "#d32f2f",
    CEO: "#d32f2f",
    Marketing: "#7b1fa2",
    IT: "#0288d1",
    HR: "#388e3c",
    Finance: "#f57c00",
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead sx={{ backgroundColor: "#ffebee" }}>
          <TableRow>
            <TableCell>User</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.ID}>
              <TableCell>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Avatar
                    sx={{
                      bgcolor: departmentColors[user._Role.Name] || "#9e9e9e",
                      mr: 2,
                      width: 32,
                      height: 32,
                    }}
                  >
                    {user.FirstName?.charAt(0)}
                  </Avatar>
                  {user.FirstName}
                </Box>
              </TableCell>
              <TableCell>{user.EmailAddress}</TableCell>

              <TableCell>{user._Role.Name}</TableCell>
              <TableCell>
                <Tooltip title="Edit user">
                  <IconButton color="primary" onClick={() => onEdit(user)}>
                    <Edit fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete user">
                  <IconButton color="error" onClick={() => onDelete(user.ID)}>
                    <Delete fontSize="small" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UserList;
